import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('usuario', 'funcionario');

const divisaoActions = {
  hierarquia: { method: 'GET', url: `${basePath}/hierarquia` },
  hierarquiaFilha: { method: 'GET', url: `${basePath}/hierarquia-filha` },
  autocomplete: { method: 'GET', url: `${basePath}/autocomplete` },
  selecao: { method: 'GET', url: `${basePath}/selecao` },
};

export default resource => resource(`${basePath}`, {}, divisaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/funcionario.js